/* eslint-disable no-unused-vars */
import { AutocompleteLocationSearch, GvAutocompleteLocationSearch, LoadingOverlay } from "../../../components";
import { Button, Grid, Typography } from "@mui/material";
import { GvCheckboxController, GvInputController, GvInputMaskController } from "../../../components/Controllers";
import React, { FC, useEffect, useState } from "react";
import {
  UserUpdateFormType,
  UserUpdateSchema,
} from "../../../services/user-update/user-update.schema";
import { useOtpVerificaton, useSentOtp } from "../../../services/otp-services/otp.services";

import { CustomToolTip } from "../../containers/EditHospitalContainer/EditHospitalContainer.style";
import { DRAWERS } from "../../../config/params";
import { FlexStyleBox } from "../../../components/GvAddPersonalDetailForm/GvAddPersonalDetailForm";
import { ILocationSearchPrediction } from "../../../services/location/location.interface";
import { IUserItemResponse } from "../../../services/user-detail/user-detail.interface";
import { InfoIcon } from "../../../components/Icons";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import UsFlagIcon from "../../../components/Icons/UsFlagIcon";
import { getPhonePattern } from "../../../utils";
import { useDrawer } from "../../../context/DrawerContext";
import { useForm } from "react-hook-form";
import { useFormattedLocation } from "../../../services/location/location.service";
import { useGTM } from "../../../hooks/useGTM";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { userActivityLogger } from "../../../utils/mixpanel";
import { yupResolver } from "@hookform/resolvers/yup";

interface ProfileEditFormProps {
  initialValue: IUserItemResponse;
  onCancel?: () => void;
  onSubmit: (data: UserUpdateFormType) => void;
}

const GvProfileEditForm: FC<ProfileEditFormProps> = ({
  initialValue,
  onCancel,
  onSubmit,
}) => {
  const { openDrawer } = useDrawer();
  const isPhoneAlreadyEnabled = initialValue.fireBasePhone ? true : false;
  const { control, setError, handleSubmit, watch, setValue, getValues, trigger, formState: { errors } } =
    useForm<UserUpdateFormType>({
      mode: "onSubmit",
      resolver: yupResolver(UserUpdateSchema),
      defaultValues: {
        firstName: initialValue.firstName || "",
        lastName: initialValue.lastName || "",
        phone: initialValue.fireBasePhone ? getPhonePattern(initialValue.fireBasePhone) :
          getPhonePattern(initialValue.phone) || "",
        isEnablePhoneLogin: isPhoneAlreadyEnabled || false,
        otp: "",
        email: initialValue.email || "",
        location: initialValue.location?.idLocation || "",
        address: initialValue?.address || null,
        placeId: initialValue?.placeId || null,
        country: "US",
        streetAddress: initialValue?.addressInfo?.streetAddress || "",
        townCity: initialValue?.addressInfo?.townCity || "",
        zipCode: initialValue?.addressInfo?.zipCode || "",
      },
    });

  const isEnablePhoneLogin = watch("isEnablePhoneLogin");

  const { dispatchEvent } = useGTM();
  const [showAddressFields, setShowAddressFields] = useState<boolean>(false);
  const { findFormatedLoction, searchData } = useFormattedLocation();
  const { handleSendVerifyOtp, sendOtpData, sendOtpError, sendOtpLoading } = useSentOtp();
  const { handlePhoneEnableOtpVerify, verifyOtpData, verifyOtpLoading, verifyOtpError } = useOtpVerificaton();
  const { user }=useUserStore();

  const [isOtpVerified, setIsOtpVerified] = useState<boolean>(false);
  const [phoneNotExistAndOtpSent, setPhoneNotExistAndOtpSent] = useState<boolean>(false);
  const [countdown, setCountdown] = useState<number>(30);

  const handleLocationSearch = (place: ILocationSearchPrediction) => {
    setValue("placeId", place?.place_id || "");
    findFormatedLoction(place?.place_id || "");
    setValue("address", place?.description || "");
    dispatchEvent({
      eventName: "gv_choose_address",
      eventProps: {
        addressValue: place?.description,
      },
    });
  };
  const phone = watch("phone").replaceAll("-", "").replaceAll(" ", "");
  const isMobileSame = phone === initialValue.fireBasePhone;
  const otp = Number(watch("otp"));

  const handleSendCode = () =>{
    handleSendVerifyOtp({ phone });
  };

  useEffect(()=>{
    if (isEnablePhoneLogin) {
      trigger("phone");
      if (phone.toString().length == 10 && phone!== initialValue.fireBasePhone && isEnablePhoneLogin === true) {
        if (phone.length == 10) {
          handleVerifyMobileAndSendCode();
        }
      };
    }
  }, [phone, isEnablePhoneLogin]);

  useEffect(() => {
    let timerId: NodeJS.Timeout;

    if (sendOtpData) {
      if (!sendOtpData.isExist) {
        setPhoneNotExistAndOtpSent(true);
        setCountdown(30);
        timerId = setInterval(() => {
          setCountdown((prevCountdown) => {
            if (prevCountdown > 0) {
              return prevCountdown - 1;
            } else {
              clearInterval(timerId);

              return 30;
            }
          });
        }, 1000);
      }
    }

    return () => {
      if (timerId) {
        clearInterval(timerId);
      }
    };
  }, [sendOtpData]);

  const handleVerifyOtp = () => {
    trigger("otp");

    if (otp.toString().length == 6) {
      const data = { phone, otp };

      handlePhoneEnableOtpVerify(data);
    }
  };

  useEffect(()=>{
    if (sendOtpError) {
      if (!isPhoneAlreadyEnabled) {
        setValue("isEnablePhoneLogin", false);
      }
      setPhoneNotExistAndOtpSent(false);

      if (sendOtpError) {
        if (sendOtpError.graphQLErrors[0].message ===
           "This phone number is already in use. Please try a different one.") {
          setError("phone", {
            message: "This phone number is already in use. Please try a different one.",
          });
        }
      }
    }
  }, [sendOtpError, setError]);

  useEffect(()=>{
    if (errors.phone) {
      if (!isPhoneAlreadyEnabled) {
        setValue("isEnablePhoneLogin", false);
      }
    }
  }, [errors.phone]);


  useEffect(()=>{
    if (otp.toString().length == 6) {
      handleVerifyOtp();
    };
  }, [otp]);

  const handleToggleLoctionsFields = (event: {
    preventDefault: () => void;
  }) => {
    event.preventDefault();
    setShowAddressFields(!showAddressFields);
  };

  useEffect(() => {
    if (searchData) {
      setValue("streetAddress", searchData?.streetAddress || "", {
        shouldValidate: false,
      });
      setValue("townCity", searchData?.townCity || "", {
        shouldValidate: false,
      });
      setValue("zipCode", searchData?.zipCode || "", { shouldValidate: true });
      setValue("country", "US", { shouldValidate: false });
    }
  }, [searchData]);

  const handleDeleteAccount = (event: { preventDefault: () => void }) => {
    userActivityLogger(MIXPANEL_EVENTS.DELETE_ACCOUNT, {
      location: user?.location?.locationName,
      msa: user?.location?.city,
    });
    event.preventDefault();
    openDrawer(DRAWERS.PROFILE_DELETE);
  };

  useEffect(()=>{
    if (verifyOtpData) {
      if (verifyOtpData) {
        setIsOtpVerified(true);
        userActivityLogger(MIXPANEL_EVENTS.VERIFY_MOB_EDIT_SUCCESS, {
          location: user?.location?.locationName,
          msa: user?.location?.city,
          mobile_number: phone,
        });
      }
    }

    if (verifyOtpError) {
      setIsOtpVerified(false);
      setValue("otp", "");
      userActivityLogger(MIXPANEL_EVENTS.VERIFY_MOB_EDIT_FAILURE, {
        location: user?.location?.locationName,
        msa: user?.location?.city,
        mobile_number: phone,
      });
    }
  }, [verifyOtpData, verifyOtpError]);

  const handleReSendCode = () => {
    userActivityLogger(MIXPANEL_EVENTS.EDIT_RESEND_OTP, {
      location: user?.location?.locationName,
      msa: user?.location?.city,
      mobile_number: phone,
    });
    handleSendCode();
  };

  const handleVerifyMobileAndSendCode = () => {
    userActivityLogger(MIXPANEL_EVENTS.VERIFY_MOB_EDIT, {
      location: user?.location?.locationName,
      msa: user?.location?.city,
      mobile_number: phone,
    });
    handleSendCode();
  };

  const isCountdownActive = countdown > 0 && countdown < 30;

  const commonClasses = "absolute right-3 px-3 cursor-pointer py-1 rounded-xl geograph-regular text-xs mt-2";
  const textColorClass = isCountdownActive ? "text-gray-1" : "text-black";
  const bgColorClass = isCountdownActive ? "!bg-[#F9EED5]" : "bg-gv-yellow";

  const resendButtonClasses = `${commonClasses} ${textColorClass} ${bgColorClass}`;

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3 pb-3">
        {(verifyOtpLoading || sendOtpLoading ) && <LoadingOverlay />}
        <div>
          <GvInputController
            control={control}
            name="firstName"
            label="First name"
            placeholder="Michael"
            className="font-semibold"
          />

          <GvInputController
            control={control}
            name="lastName"
            label="Last name"
            placeholder="Smith"
            className="font-semibold"
          />

          <div>
            <div className="text-[0.8rem] font-semibold">Mobile Number</div>
            <div className="flex gap-1">
              <div className="w-32 mt-[0.35rem]">
                <div className="text-gray-1 flex items-center justify-start
                bg-white border border-gray-3 h-[2.65rem] px-3 rounded gap-2">
                  <UsFlagIcon /> +1
                </div>
              </div>
              <GvInputMaskController
                control={control}
                name="phone"
                label=""
                mask="999-999-9999"
                placeholder="XXX-XXX-XXXX"
                disabled={phoneNotExistAndOtpSent && !!getValues("isEnablePhoneLogin")}
                className="font-semibold"
              />
            </div>
          </div>
          {/* -----old design component----- */}
          <FlexStyleBox>

            <GvCheckboxController
              control={control}
              name="isEnablePhoneLogin"
              label="Enable phone number login"
              disabled={isPhoneAlreadyEnabled || isOtpVerified}
              fullWidth={false}
            />

            <CustomToolTip
              title={
                <Typography color="inherit">
                  We use a verification code to
                  confirm your mobile number and protect your account.<br/>
                  Enter the code sent to your phone to complete verification.
                </Typography>
              }
              sx={{ marginBottom: "-1rem !important" }}
              placement="top"
            >
              <div className="pb-[0.95rem] text-yellow-500 text-lg font-normal leading-6">
                <InfoIcon />
              </div>
            </CustomToolTip>
          </FlexStyleBox>
          {/* -----old design component----- */}
          <GvInputController
            control={control}
            disabled
            name="email"
            label="Email address"
            placeholder="Enter your email"
            className="font-semibold"
          />


          {!errors.phone && phoneNotExistAndOtpSent && !isMobileSame && isEnablePhoneLogin ? (
            <div className="relative flex items-center">
              <GvInputController
                control={control}
                name="otp"
                label="Verification Code"
                placeholder="Enter Code"
                sx={{ flex: 1 }}
                disabled={isOtpVerified}
                inputProps={{ maxLength: 6 }}
              />
              {!isOtpVerified ? <button type="button"
                onClick={handleReSendCode}
                disabled={isCountdownActive}
                className={resendButtonClasses}
              >
                {isCountdownActive ? `Resend code in ${countdown}s` : "Resend Code"}
              </button>:
                isOtpVerified ? <span
                  className="absolute right-3 px-3 py-1 rounded-xl geograph-regular text-xs mt-2 bg-mint">
                  Verified
                </span> : null
              }
            </div>): null}
          <GvAutocompleteLocationSearch
            disable={showAddressFields}
            searchValue={getValues("address") || ""}
            onSelect={handleLocationSearch}
            control={control}
            label={showAddressFields ? "Enter Your Address" : "Mailing Address"}
            className="font-semibold"
          />

          <div style={{ textAlign: "right" }}>
            <a
              href="#"
              onClick={handleToggleLoctionsFields}
              style={{
                fontSize: 14,
                color: showAddressFields ? "gray" : "black",
              }}
            >
              Update Address
            </a>
          </div>

          {showAddressFields && (
            <>
              <GvInputController
                control={control}
                name="streetAddress"
                label="Street Address"
                placeholder="Enter Street Address"
              />

              <GvInputController
                control={control}
                name="townCity"
                label="Town/City"
                placeholder="Enter Town/City"
              />

              <GvInputController
                control={control}
                name="zipCode"
                label="Zip Code"
                placeholder="Enter Zip Code"
              />
            </>
          )}

        </div>

        <Button
          fullWidth
          variant="contained"
          id="profileupdateButton"
          type="submit"
          className="!capitalize !font-semibold"
          disabled={(!isMobileSame && !isOtpVerified && isPhoneAlreadyEnabled) ||
          (isEnablePhoneLogin && !isOtpVerified && !isPhoneAlreadyEnabled) || !!errors.phone
          }>Save</Button>
      </form>
    </>
  );
};

export default GvProfileEditForm;
